/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import dayjs from 'dayjs';
import { validateDate } from 'ember-changeset-validations/validators';
import type { ValidatorMap } from 'ember-changeset/types';
import type { ForcModelPojo } from 'parog-web/components/forc/abstract/journal-event-based-component';
import BaseMedicalHistoryFormComponent from 'parog-web/components/medical-history/abstract/base-edition-form';
import MedicalHistoryBaseEditionForm from './base-edition-form';
import MentalBipolarDiagnostic from './mental/bipolar/diagnostic-fields';
import MentalDepressionDiagnostic from './mental/depression/diagnostic-fields';
import MentalGenericDiagnostic from './mental/mental-generic/diagnostic-fields';

const DiagnosticFields = {
  'mental-generic': MentalGenericDiagnostic,
  bipolar: MentalBipolarDiagnostic,
  depression: MentalDepressionDiagnostic
};

export default class MentalwiseMedicalHistoryEditionForm extends BaseMedicalHistoryFormComponent {
  static override fullComponentId = 'medical-history/edition';

  depressionPathologyProperties = [
    'numberOfTs',
    'suicideRisk',
    'suicidalThoughtsStartDate'
  ];
  override journalEventProperties = [
    'mainDiagnosis',
    'diagnosisDate',
    ...this.sharedProperties,
    ...this.depressionPathologyProperties
  ];

  get diagnostic(): TemplateOnlyComponent {
    return DiagnosticFields[this.patho ?? ''];
  }

  override get validations(): ValidatorMap {
    const validations = {
      diagnosisDate: [
        validateDate({
          allowBlank: true,
          message:
            'Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date',
          onOrAfter: new Date('01/01/1900')
        }),
        validateDate({
          allowBlank: true,
          message:
            'Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date',
          onOrBefore: dayjs().endOf('day').toDate()
        })
      ],
      suicidalThoughtsStartDate: [
        validateDate({
          allowBlank: true,
          message:
            'Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date',
          onOrAfter: new Date('01/01/1900')
        }),
        validateDate({
          allowBlank: true,
          message:
            'Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date',
          onOrBefore: dayjs().endOf('day').toDate()
        })
      ]
    };

    return validations;
  }

  override retrieveJournalEvent = () =>
    this.args.patient.medicalHistoryChangedJournalEvent;

  override retrieveModel(): ForcModelPojo {
    const model = super.retrieveModel();

    if (!model.mainDiagnosis) {
      model.mainDiagnosis = 'unknown';
    }

    return model;
  }

  <template>
    <MedicalHistoryBaseEditionForm
      {{! @glint-expect-error }}
      @forcComponent={{this}}
      @patient={{@patient}}
      as |mh|
    >
      <mh.FurSection />
      <mh.FurDetailsSection @diagnostic={{this.diagnostic}} />
      <mh.ComorbiditiesAllergiesSection />
      {{! @glint-expect-error }}
      <mh.PathologySection />
      <mh.VaccinesSection />
      <mh.CommentsSection />
    </MedicalHistoryBaseEditionForm>
  </template>
}
